
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/artist/[artistSlug]",
      function () {
        return require("private-next-pages/d/artist/[artistSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/artist/[artistSlug]"])
      });
    }
  